// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, SpeedDial, SpeedDialIcon, SpeedDialAction, Tab, Tabs, Typography, } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// TODO: Import MUI icon
import { MenuBook } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import Slide from '../Slide_LT.jpg';

import BoxSubPage from '../../Common/BoxSubPage';
import BoxImage from '../../Common/BoxImage';
import { BoxGridColumnsContainer } from '../../Common/BoxGridColumns';

const EnglishEducation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component EnglishEducation Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const actions = ['English Ambassador Team', `'English is Everywhere' Scheme`];
    const [value, setValue] = React.useState(actions[0]);
    const [open, setOpen] = React.useState(false);

    // TODO: Define event
    const theme = useTheme();

    const handleChange = (event, newValue) => { setValue(newValue) };

    React.useEffect(() => { window.scrollTo(0, 0); }, [value]);
    React.useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.innerHeight + window.scrollY;
            const documentHeight = document.documentElement.scrollHeight;

            if (documentHeight - scrollPosition < 200) {
                setOpen(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // TODO: Return component
    return (
        <BoxSubPage
            id="EnglishEducation"
            image={Slide}
            title={Text.Top.Menu['LT'].Title[context.language]}
            subtitles={Text.Top.Menu['LT'].Subtitles}
        >
            <Box sx={{ display: { xs: 'none', md: 'inline' }, mb: 2, width: 1 }}>
                <Tabs value={value} onChange={handleChange}>
                    {actions.map((action) => <Tab key={action} icon={<MenuBook />} value={action} label={action} />)}
                </Tabs>
            </Box>
            <Typography variant="h6" sx={{ color: 'primary.main', mb: 2, display: { xs: 'inline', md: 'none' } }}>{value}</Typography>
            <SpeedDial
                ariaLabel="SpeedDial tooltip example"
                sx={{ alignItems: 'end', display: { xs: 'flex', md: 'none' }, position: 'fixed', bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                open={open}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action}
                        FabProps={{
                            sx: {
                                backgroundImage: `linear-gradient(90deg, ${theme.palette.secondary.dark}, ${theme.palette.secondary.light})`,
                                backgroundSize: '200% 200%',
                                justifyContent: 'start',
                                maxWidth: '300px',
                                '&:hover': { backgroundColor: 'secondary.light', },
                            },
                            variant: 'extended'
                        }}
                        icon={
                            <Typography
                                style={{
                                    alignItems: 'center',
                                    color: 'black',
                                    display: 'flex',
                                    gap: 8,
                                    textDecoration: 'none',
                                }}
                            >
                                <MenuBook/>
                                <span dangerouslySetInnerHTML={{ __html: action }}></span>
                            </Typography>
                        }
                        onClick={() => {
                            setOpen(false);
                            setValue(action);
                        }}
                    />
                ))}
            </SpeedDial>
            {value === 'English Ambassador Team' &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishAmbassadorTeam.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography sx={{ mb: 1 }}>
                        Our English Ambassador Team is a vibrant group of students from Forms 2 to 5 dedicated to promoting an engaging English-speaking environment within our school. Comprising of 30 enthusiastic members, including inspiring leaders and vice-leaders, this team organises fun lunchtime activities - like board and card games - catering to students from all forms. Other English Ambassador Team duties include holding engaging and entertaining English morning assemblies and designing themed activities for the school.
                    </Typography>
                    <Typography sx={{ mb: 1 }}>
                        With the guidance of our Native English Teachers, English Ambassadors not only make learning English enjoyable but also serve as positive role models for their peers. Their mission is simple - to create a friendly and encouraging space where English thrives!
                    </Typography>
                </Box>}
            {value === `'English is Everywhere' Scheme` &&
                <Box>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishIsEverywhereScheme_03.jpg" sx={{ mb: 1, width: 1 }} />
                    <Typography>
                        The 'English is Everywhere' scheme is designed specifically for Form 1 and Form 2 students eager to enhance their English language skills. Open three lunchtimes a week, students are invited to pop into the English Corner any day where they can chat with Native English Teachers and English Ambassadors in a relaxed atmosphere. They can play fun board games, receive help with homework, and enjoy learning in a friendly and laid-back environment. This engaging rewards program allows students to collect stamps in their booklets for participation, leading to exciting prizes and extra credits in class marks. Every visit not only earns them rewards but also enriches their English language journey - because English truly is everywhere!
                    </Typography>
                    <BoxGridColumnsContainer>
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishIsEverywhereScheme_02.jpg" />
                        <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/EnglishIsEverywhereScheme_01.jpg" />
                    </BoxGridColumnsContainer>
                </Box>}
        </BoxSubPage>
    );
};
export default EnglishEducation;